import { render, staticRenderFns } from "./FABDialog.vue?vue&type=template&id=5c7b66b1&scoped=true"
import script from "./FABDialog.vue?vue&type=script&lang=js"
export * from "./FABDialog.vue?vue&type=script&lang=js"
import style0 from "./FABDialog.vue?vue&type=style&index=0&id=5c7b66b1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c7b66b1",
  null
  
)

export default component.exports